import React, { useContext } from 'react'
import CollaboratorsTable from '../../../../CollaboratorsPage/components/CollaboratorsTable/CollaboratorsTable'
import { GeneralContext } from '../../../../../GeneralProvider';
import { useLanguage } from '../../../../../LanguageProvider';
import { useToaster } from '../../../../../ToasterProvider';

export default function SentInvites() {
    const { toastSuccess, toastError } = useToaster();
    const { getTranslation } = useLanguage();
    const {
        handleRemoveUserFromProject,
        sentProjectInvitations,
        handleResendProjectInvitation
    } = useContext(GeneralContext);

    const sentInvitationsHeaders = [
        getTranslation("name") + " " + getTranslation("lastname"),
        getTranslation("email"),
        getTranslation("status"),
        getTranslation("actions")
    ];


    const sentInvitationsData = sentProjectInvitations?.map((invitation) => {
        // Eğer davetiye "Sent" ise, status sütunu "Sent" olarak kalırken, actions sütununda butonlar yer alsın.
        if (invitation.status === "3") {
            return {
                nameLastname: `${invitation.name} ${invitation.lastname}`,
                email: invitation.email,
                status: getTranslation("sent"),
                actions: (
                    <div className="collaborators-table-status-holder">
                        <button
                            onClick={() => handleCancelInvitation(invitation.authID)}
                            className="collaborators-table-reject-button"
                        >
                            {getTranslation("cancel")}
                        </button>

                        <button
                            onClick={() => handleResendInvitation(invitation.authID)}
                            className="collaborators-table-resend-button"
                        >
                            {getTranslation("resend")}
                        </button>
                    </div>
                ),
            };
        } else {
            // Örneğin davetiye Accepted ise
            return {
                nameLastname: `${invitation.name} ${invitation.lastname}`,
                email: invitation.email,
                status: getTranslation("accepted"),
                actions: ""
            };
        }
    });

    const sentInvitationsDataFieldMapping = {
        [getTranslation("name") + " " + getTranslation("lastname")]: "nameLastname",
        [getTranslation("email")]: "email",
        [getTranslation("status")]: "status",
        [getTranslation("actions")]: "actions", // Mapping yeni sütun için
    };

    const handleCancelInvitation = async (authID) => {
        try {
            handleRemoveUserFromProject(authID)
            toastSuccess(getTranslation("successMessage"));
        } catch (error) {
            toastError(getTranslation("somethingWentWrong"));
        }
    };

    const handleResendInvitation = async (authID) => {
        try {
            handleResendProjectInvitation(authID)
            toastSuccess(getTranslation("successMessage"));
        } catch (error) {
            toastError(getTranslation("somethingWentWrong"));
        }
    };

    return (
        <>
            <p className="collaborators-title">
                {getTranslation("inviteList")}
            </p>
            <CollaboratorsTable
                headers={sentInvitationsHeaders}
                data={sentInvitationsData}
                fieldMapping={sentInvitationsDataFieldMapping}
            />
        </>
    )
}
